import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const plexTrac = defineConnector({
  identifier: "plexTrac",
  name: "PlexTrac",
  tagLine: "Security reporting and findings",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://demo\\.plextrac\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a JWT access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://docs.plextrac.com/plextrac-documentation/api-documentation/getting-started](https://docs.plextrac.com/plextrac-documentation/api-documentation/getting-started) to authenticate and obtain a JWT access token for the PlexTrac API. PlexTrac sends that token in the `Authorization` header on later requests.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "baseUrl",
          label: "PlexTrac base URL",
          placeholder: "https://demo.plextrac.com",
          required: true,
          target: {
            kind: "configuration",
            field: "url",
          },
        },
        {
          kind: "input",
          label: "JWT access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://demo.plextrac.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url: testUrl ?? (({ url }) => `${url}/api/v1/me`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
